export enum SchedulingType {
  Weekly = 'WEEKLY',
  Daily = 'DAILY',
}
